import { Location } from '@angular/common';
import { Component, DoCheck, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { LogService } from 'app/lib/log.service';
import { SeriesService } from 'app/lib/series.service';
import { voice } from 'app/models/course';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-series-voices-burningquestions',
    templateUrl: './series-voices-burningquestions.component.html',
    styleUrls: ['./series-voices-burningquestions.component.scss'],
    standalone: false
})
export class SeriesVoicesBurningquestionsComponent implements OnInit, DoCheck {
    categoryList = [];
    selectedCategoryId: number = 0;
    burningQuestionList: voice[] = [];
    categorizedBurningQuestionList: any[] = [];
    lang: string = 'en';
    popups: any;
    customOptions: OwlOptions = {
        loop: false,
        margin: 16,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        dots: false,
        navSpeed: 700,
        autoWidth: false,
        navText: [
            '<img src="../../../assets/img/series/left-arrow.svg" width="24" height="24"/>',
            '<img src="../../../assets/img/series/right-arrow.svg" width="24" height="24"/>',
        ],
        responsive: {
            0: { items: 1, slideBy: 1 },
            580: { items: 1, slideBy: 1 },
            600: { items: 1, slideBy: 1 },
            768: { items: 2, slideBy: 1 },
            1000: { items: 3, slideBy: 1 }, // Dynamic item count based on content
            1400: { items: 4, slideBy: 1 },
        },
        nav: true,
    };
    loaded: boolean = false;
    constructor(
        private translate: TranslateService,
        private activatedRoute: ActivatedRoute,
        private seriesService: SeriesService,
        private log: LogService,
        private location: Location,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.lang = this.translate.currentLang;
        this.log.event(
            AnalyticEvent.internalPagesEvents.burningQuestionsListingPage
        );
        this.initalizePageData();
    }
    ngDoCheck() {
        this.lang = this.translate.currentLang;
    }
    initalizePageData() {
        this.selectedCategoryId =
            +this.activatedRoute.snapshot.paramMap.get('category') || 0;
        // this.getCategoryList();
        this.getBurningQuestionsList();
    }
    getCategoryList() {
        this.seriesService.categories.subscribe(data => {
            this.categoryList = data;
        });
        this.seriesService.getCategories();
    }
    getBurningQuestionsList() {
        this.seriesService.voiceBurningQuestionSeries.subscribe((data: any) => {
            if (!data || data.status == 'error') return;
            if (data.status == 'success') {
                this.setBurningQuestionsSeries(data.seriesList);
            }
        });
        this.seriesService.getBurningQuestionsSeries();
    }
    setBurningQuestionsSeries(series: any) {
        if (!Object.keys(series).length) {
            return;
        } else {
            this.loaded = true;
            this.burningQuestionList = voice.initializeArray(
                series,
                'burningQuestion'
            );

            this.categorizedBurningQuestionList =
                this.categorizeBurningQuestionList([
                    ...this.burningQuestionList,
                ]);
            this.getFilteredList();
        }
    }
    categorizeBurningQuestionList(input: any[]) {
        return Object.values(
            input.reduce(
                (acc, item) => {
                    const { categoryDetails, ...rest } = item;
                    const { ID, Key } = categoryDetails;
                    if (!acc[Key]) {
                        acc[Key] = {
                            categoryKey: Key,
                            categoryId: ID,
                            data: [],
                        };
                    }
                    acc[Key].data.push(rest);
                    return acc;
                },
                {} as Record<
                    number,
                    { categoryId: number; categoryKey: string; data: any[] }
                >
            )
        );
    }
    getFilteredList() {
        if (this.selectedCategoryId == 0) {
            return this.burningQuestionList;
        }
        return this.burningQuestionList.filter(
            item => item.category === this.selectedCategoryId
        );
    }
    goBack() {
        this.location.back();
    }
    goToVoiceStory(type, story) {
        this.router.navigate(['/app/series/voices/' + type + '/' + story.id])
            .then(() => {
                this.resetScroll();
            });
    }

    resetScroll() {
        // Immediately reset window scroll
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        
        // Try multiple times with increasing delays to ensure scroll resets
        [0, 50, 100, 150].forEach(delay => {
            setTimeout(() => {
                window.scrollTo(0, 0);
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                
                const detailsSection = document.querySelector('.details-top-section');
                if (detailsSection) {
                    detailsSection.scrollTop = 0;
                }

                const appPage = document.querySelector('.app-l-page');
                if (appPage) {
                    appPage.scrollTop = 0;
                }
                
                const main = document.querySelector('main');
                if (main) {
                    main.scrollTop = 0;
                }
            }, delay);
        });
    }
    // itemsList = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6'];

    // getItemsCount(): number {
    //     return this.itemsList.length <= 3 ? this.itemsList.length : 6;
    // }
}
